var exports = {
  "p": "SidebarResizeHandle.module__handle___VXlCM2",
  "q": "SidebarResizeHandle.module__indicator___VXlCM2",
};

module.exports = exports;
